export default "__VITE_ASSET__DdWimt79__"